import Image from 'next/image'
import IllustrationLeft from '@/blocks/TrialLesson/illustration_left.jpg'
import IllustrationRight from '@/blocks/TrialLesson/illustration_right.jpg'
import { TrialLessonBlock } from '@/src/@types/statamic'
import Button from '@/src/components/core/Button'
import CustomLink from '@/src/components/elements/CustomLink'

export function getTitle({ title }: TrialLessonBlock) {
  return title
}

export default function Component({
  title,
  required_text: text,
  link_link,
  link_text,
}: TrialLessonBlock) {
  return (
    <div className="mt-20 flex flex-col justify-center md:mt-32 lg:flex-row">
      <div className="relative h-79.75 grow lg:h-auto">
        <Image
          sizes="1000px"
          alt="Probelektion Illustration"
          src={IllustrationLeft}
          fill
          className="object-cover object-[50%_0%] lg:object-[70%_30%]"
          unoptimized
        />
      </div>
      <div className="relative z-50 -order-1 shrink-0 lg:order-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 74 480"
          className="absolute inset-y-0 left-0.5 hidden h-full -translate-x-full drop-shadow-2xl lg:block"
        >
          <path
            fill="#6a29ec"
            d="M72 480C26.494 411.17 0 328.679 0 240S26.494 68.83 72 0h2v480z"
          />
        </svg>
        <div className="relative z-50 bg-purple-600 px-5 pt-12 text-center text-white lg:py-24">
          <div className="mx-auto max-w-172">
            <h2 className="text-4xl font-black md:text-20xl">{title}</h2>
            <p className="mt-4 md:text-lg">{text}</p>
            {link_link?.url && link_text && (
              <CustomLink href={link_link.url} passHref>
                <Button as="a" version="white-gray" className="mt-8">
                  {link_text}
                </Button>
              </CustomLink>
            )}
          </div>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 74 480"
          className="absolute inset-y-0 right-0.5 hidden h-full translate-x-full drop-shadow-2xl lg:block"
        >
          <path
            fill="#6a29ec"
            d="M2 480c45.506-68.83 72-151.321 72-240S47.506 68.83 2 0H0v480z"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 393 50"
          preserveAspectRatio="none"
          className="absolute inset-x-0 bottom-0.5 h-12.5 w-full translate-y-full drop-shadow-2xl lg:hidden"
        >
          <path
            fill="#6a29ec"
            fill-rule="evenodd"
            d="M196 50C128.438 50 62.79 45.023 0 35.637V0h393v35.484C329.906 44.97 263.922 50 196 50"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <div className="relative hidden grow lg:block">
        <Image
          sizes="1000px"
          alt="Probelektion Illustration"
          src={IllustrationRight}
          fill
          className="object-cover"
          unoptimized
        />
      </div>
    </div>
  )
}
